<template>
  <div class="px-2 pt-2 p-md-0">
    <div class="text-center p-5 m-5" v-if="!post">
      <div class="spinner-border text-secondary" role="status">
        <span class="sr-only">Loading...</span>
      </div>
    </div>
    <div v-if="post">
      <h4 class="mb-1" v-html="post.Title"></h4>
      <div class="mb-4">
        <i class="article-date">{{ new Date(Date.parse(post.Created)) | dateFormat('DD.MM.YYYY') }}</i>
      </div>
      <div v-html="post.Article"></div>
    </div>
  </div>
</template>

<script>
import axios from 'axios'

export default {
  name: 'Post',
  data () {
    return {
      post: null
    }
  },
  created () {
    this.getPost()
  },
  methods: {
    async getPost () {
      const code = this.$router.currentRoute.params.code
      let response = []
      try {
        response = await axios.get(`/posts/${code}`)
      } catch (error) {
        return
      }

      document.title = response.data.Metatitle
      this.post = response.data
    }
  }
}
</script>

<style lang="scss" scoped>
  .article-image {
    width: 100%;
  }
  .article-date {
    font-size: 0.8em;
  }
</style>



// WEBPACK FOOTER //
// src/components/Posts/Post.vue